import * as React from "react";
import {TaskInterface} from "../Todoist/Task";
import {Collection} from "../Todoist/Main";
import {Week} from "./TimeReserv";
import { LabelInterface} from "../Todoist/Labels";


export class Menu extends React.Component {



    render() {
        return <>

            <div style={{height: "30px",marginBottom:"25px"}}>


                <a style={{margin:"10px"}} href="/">День</a>
                <a style={{margin:"10px"}} href="/week-line.html">Неделя</a>
                <a style={{margin:"10px"}} href="/plan.html">Неделя планирование</a>
                <a style={{margin:"10px"}} href="/schedule-week.html">Расписание </a>


            </div>


        </>;
    }


}

export class Filter extends React.Component<{title:string, value:string, isActive: boolean, handlerChange: ()=>void}>{





    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return <span className={"filter-label__item"}><label><input onChange={this.props.handlerChange} checked={this.props.isActive} type={"checkbox"} value={this.props.value}/>{this.props.title}</label></span>
        // return <a onClick={() => this.props.applyFilter}>kkk</a>;
    }
}

export class MainFilter extends React.Component<{component: Week, tasks: Collection<TaskInterface> }> {


    private filteredByLabels: number[] = [];

    private filter: {
        label: Collection<LabelInterface>
    };


    public state: {
        tasks: Collection<TaskInterface>
        , filter?: {
            label: number
        }
    };

    constructor(public props: {component: Week, tasks: Collection<TaskInterface> }){
        super(props);
        this.state = {
            tasks: this.props.tasks
        };
        this.filter = {
            label: new Collection<LabelInterface>()
        }

        this.props.tasks.getItems().forEach((item) => {
            item.getLabels().getItems().forEach((label) => {
                this.filter.label.addItem(label)
            })
        });

    }


    action(){
        this.setState({tasks: new Collection()})
    }

    byLabel(value: number){

        let index = this.filteredByLabels.indexOf(value);
        if(index == -1){
            this.filteredByLabels.push(value);
        }else {
            this.filteredByLabels.splice(index, 1);
        }

        let tasks = new Collection(this.props.tasks.getItems());

        if(this.filteredByLabels.length > 0) {
            tasks = tasks.filter(item => !!item.getLabels().find((item) => (this.filteredByLabels.indexOf(item.getId()) != -1))
            );
        }

        this.setState({tasks: tasks});
    }



    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        //console.log("TST",this.props.tasks);
        this.props.component.props.tasks = this.state.tasks;

        return <div>

            <div className={"filter-label"}>
            {this.filter.label.getItems().map( (label) => {
                return <Filter key={label.getId()} title={label.getName()} value={label.getId()} isActive={this.filteredByLabels.indexOf(label.getId()) !== -1} handlerChange={() => this.byLabel(label.getId())}/>
            })}
            </div>



            {(this.props.component.render())}</div>;
    }

}